import axios from 'axios';

// Dynamic base URL for development and production live environment
export const API_BASE_URL = import.meta.env.DEV
  ? (import.meta.env.VITE_API_URL || 'http://localhost:5000/api')
  : (import.meta.env.VITE_API_URL || 'https://hrms.digikininfotech.in/api');

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to attach the auth token
apiClient.interceptors.request.use(
  (config) => {
    // Attempt to get the token from sessionStorage
    const storedUser = sessionStorage.getItem('hrms_user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        // Assuming your backend expects a Bearer token and your user object contains a 'token' field
        if (user && user.token) {
          config.headers.Authorization = `Bearer ${user.token}`;
        }
      } catch (error) {
        console.error('Failed to parse user from session storage', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle global errors (like 401 Unauthorized)
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Check if this is a login request to avoid infinite reload loop/refresh on login failure
      const isLoginRequest = error.config && error.config.url && error.config.url.includes('login');
      if (!isLoginRequest) {
        sessionStorage.removeItem('hrms_user');
        window.location.href = '/login';
      }
    }

    // Handle 429 Too Many Requests (Rate Limiting)
    if (error.response && error.response.status === 429) {
      alert('Too many requests. Please wait a moment before trying again.');
    }

    return Promise.reject(error);
  }
);
